const WORDS = ["Collection 2027", "Moisture Resistant", "18mm Thicker Board", "Two Signature Finishes", "Made for Modern Homes"];

export const Marquee = () => (
  <div className="overflow-hidden border-y border-ink/10 bg-ink py-6 text-bone" data-testid="marquee">
    <div className="marquee-track flex w-max">
      {[0, 1].map((k) => (
        <div key={k} className="flex shrink-0 items-center" aria-hidden={k === 1}>
          {WORDS.map((w) => (
            <span key={w} className="flex items-center font-display text-3xl italic md:text-5xl">
              <span className="px-8">{w}</span>
              <span className="text-clay">✳</span>
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
